import React from 'react';
import type { RowCellType } from '@atlaskit/dynamic-table/types';
import type { Plan } from '@atlassian/jira-plans-main/src/common/types';
import { ARCHIVED_STATUS, TRASHED_STATUS } from '../../../common/constants';
import type { RefetchPlans, Status } from '../../../common/types';
import ArchiveActionsCell from './cells/archive-actions-cell/index.tsx';
import TrashActionsCell from './cells/trash-actions-cell/index.tsx';

export const getArchivedProjectsCells = (plan: Plan, refetchPlans: RefetchPlans): RowCellType[] => [
	{
		content: <ArchiveActionsCell plan={plan} refetchPlans={refetchPlans} />,
	},
];

export const getTrashProjectsCells = (plan: Plan, refetchPlans: RefetchPlans): RowCellType[] => [
	{
		content: <TrashActionsCell plan={plan} refetchPlans={refetchPlans} />,
	},
];

export const getColumnsByStatus = (
	status: Status,
	plan: Plan,
	refetchPlans: RefetchPlans,
): RowCellType[] => {
	if (status === ARCHIVED_STATUS) {
		return getArchivedProjectsCells(plan, refetchPlans);
	}
	if (status === TRASHED_STATUS) {
		return getTrashProjectsCells(plan, refetchPlans);
	}
	return [];
};
